/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Samples_ReasonInputs */

const en_samples_reason = /** @type {(inputs: Samples_ReasonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reason`)
};

const es_samples_reason = /** @type {(inputs: Samples_ReasonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Razon`)
};

/**
* | output |
* | --- |
* | "Reason" |
*
* @param {Samples_ReasonInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const samples_reason = /** @type {((inputs?: Samples_ReasonInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Samples_ReasonInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_samples_reason(inputs)
	return es_samples_reason(inputs)
});